import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getSearchRequestParams } from 'reactApp/modules/search/search.selectors';
import { SearchItem } from 'reactApp/modules/search/search.types';
import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { Kind } from 'reactApp/types/Tree';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

export const useSendSearchActionBarAnalytics = (storage: EStorageType) => {
    const { query, xPageId, xReqId } = useSelector(getSearchRequestParams);
    const selectedItems = useSelector(SelectionsSelectors.getSelectedItems);

    return useCallback(
        (action: string) => {
            const { isSearch } = getStorage(storage);

            if (!isSearch) {
                return;
            }

            const storeItems = selectedItems as SearchItem[];
            sendDwh({
                eventCategory: ECategoryGa.toolbar_search,
                action,
                dwhData: {
                    count_files: selectedItems.length,
                    place: 'touch',
                    section: 'search',
                    search_phrase: query,
                    page_id: xPageId,
                    req_id: xReqId,
                    count_media: 0,
                    name_files: storeItems.map((item) => item.name).join('##'),
                    type_content: storeItems.map((item) => item.kind).join('##') as Kind,
                    pos: storeItems.map((item) => item.pos).join('##'),
                    hash: storeItems.map((item) => (item.isFolder ? ' ' : item.hash)).join('##'),
                    size: storeItems.map((item) => (item.isFolder ? ' ' : item.size)).join('##'),
                },
            });
        },
        [query, selectedItems, storage, xPageId, xReqId]
    );
};
